import AccountingNotifc from "@/views/accounting/TheNotifc.vue";

import TasahelReports from "@/views/accounting/Requests/TasahelReports.vue";
import TasahelUnderReports from "@/views/accounting/Requests/TasahelUnderReports.vue";

import WsataReports from "@/views/accounting/Requests/WsataReports.vue";
import WsataUnderReports from "@/views/accounting/Requests/WsataUnderReports.vue";

import AccountingAnnouncements from "@/views/accounting/Announcements/AnnouncementsIndex.vue";

import TheCalendarLastVersion from "@/views/accounting/Calender.vue";

export const accountingRouter = [
    {
        path: "/accounting/notifications",
        name: "accountingNotifications",
        component: AccountingNotifc,
        meta: {
            icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="18.552" height="19" viewBox="0 0 20.552 21">
          <g id="message_1_" data-name="message (1)" transform="translate(1 1)">
            <g id="bell">
              <line id="Line_3" data-name="Line 3" x2="3" transform="translate(8 19)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_2642" data-name="Path 2642" d="M22.552,19.179H4a3.044,3.044,0,0,0,1.687-2.732V11.59A7.59,7.59,0,0,1,13.276,4h0a7.59,7.59,0,0,1,7.59,7.59v4.857a3.044,3.044,0,0,0,1.687,2.732Z" transform="translate(-4 -4)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
          </g>
        </svg>
        `,
            listed: true,
            group: '',
            page_name: "الإشعارات",
        },
    },
    
    
    // Reports fro Tasaheel 
    {
        path: "/accounting/tsaheelreports",
        name: "accountingTasahelReports",
        component: TasahelReports,
        meta: {
            icon: "",
            listed: true,
            group: " التقارير",
            page_name: "لتساهيل - مفرغة",
            breadcrumb: "",
            badge: true,
            badge_count: "f_all",
            badge_color: '#000000',
            badge_f_color: '#ffffff'
        },
    },
    
    {
        path: "/accounting/tsaheel-under-reports",
        name: "accountingTasahelReportsUnder",
        component: TasahelUnderReports,
        meta: {
            icon: "",
            listed: true,
            group: " التقارير",
            page_name: "لتساهيل - تحت المعالجة",
            breadcrumb: "",
        },
    },

    // Reports fro Wasata accountants

    {
        path: "/accounting/wasatareports",
        name: "accountingWasataReports",
        component: WsataReports,
        meta: {
            icon: "",
            listed: true,
            group: "التقارير.",
            page_name: "للوساطة - مفرغة",
            breadcrumb: "",
            badge: true,
            badge_count: "f_all",
            badge_color: '#000000',
            badge_f_color: '#ffffff'
        },
    },
    
    {
        path: "/accounting/wasata-under-reports",
        name: "accountingWasataReportsUnder",
        component: WsataUnderReports,
        meta: {
            icon: "",
            listed: true,
            group: "التقارير.",
            page_name: "للوساطة - تحت المعالجة",
            breadcrumb: "",
        },
    },

    // announcements
    {
        path: "/accounting/announcements",
        name: "accountingAnnouncements",
        component: AccountingAnnouncements,
        meta: {
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="17.599" height="17.468" viewBox="0 0 17.599 17.468">
          <g id="_Group_" data-name=" Group " transform="translate(-38 -39.966)">
            <path id="_Compound_Path_" data-name=" Compound Path " d="M53.721,39.966a1.884,1.884,0,0,0-1.864,1.639c-.741.56-4.107,2.964-7.288,2.964H40a2.006,2.006,0,0,0-2,2.008v3.132a2,2,0,0,0,1.99,2h.268l1.309,4.272a2,2,0,1,0,3.843-1.1,13.524,13.524,0,0,1-.432-3.144c3.185.182,6.2,2.409,6.882,2.944a1.876,1.876,0,0,0,3.738-.24V41.85a1.88,1.88,0,0,0-1.876-1.884Zm-9.546,10.94H40.987v-5.53h3.189Zm-5.368-1.2V46.584A1.2,1.2,0,0,1,40,45.376h.184v5.53H40a1.189,1.189,0,0,1-1.2-1.181Zm5.066,6.822a1.183,1.183,0,0,1-.932-.061,1.2,1.2,0,0,1-.6-.722L41.1,51.713h3.069a14.457,14.457,0,0,0,.46,3.375,1.2,1.2,0,0,1-.758,1.443Zm1.109-5.6V45.362a12.081,12.081,0,0,0,5.044-1.622,19.53,19.53,0,0,0,1.818-1.127V53.661A17.7,17.7,0,0,0,50.1,52.554,12.316,12.316,0,0,0,44.983,50.93Zm9.808,3.513a1.07,1.07,0,1,1-2.139,0V41.849a1.07,1.07,0,0,1,2.139,0Z" transform="translate(0)" fill="#fff"/>
          </g>
        </svg>`,
            listed: true,
            group: '',
            page_name: "التعميمات",
        },
    },

     {
        path: "/accounting/calender",
        name: "accountingCalender",
        component: TheCalendarLastVersion,
        meta: {
            icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="17.599" height="18.22" viewBox="0 0 17.599 18.22">
            <path id="reminder" d="M19.967,18.29a2.376,2.376,0,0,1-.7-1.278c0-.015,0-.029,0-.043V15.339A2.545,2.545,0,0,0,17.3,12.85V5.3a2.2,2.2,0,0,0-2.2-2.2H13.137V2.587a.44.44,0,0,0-.88,0V3.1H7.544V2.587a.44.44,0,0,0-.88,0V3.1H4.7A2.2,2.2,0,0,0,2.5,5.3v10.41a2.2,2.2,0,0,0,2.2,2.2h9.041a3.559,3.559,0,0,1-.311.377.44.44,0,0,0,.308.754h1.521a1.44,1.44,0,0,0,2.871,0h1.528a.44.44,0,0,0,.308-.754ZM4.7,3.984H6.664v.521a.44.44,0,1,0,.88,0V3.984h4.713v.521a.44.44,0,1,0,.88,0V3.984H15.1a1.32,1.32,0,0,1,1.32,1.32v.9H3.38V5.3A1.32,1.32,0,0,1,4.7,3.984Zm0,13.049a1.32,1.32,0,0,1-1.32-1.32V7.082H16.421V12.8a2.56,2.56,0,0,0-2.282,2.541v1.674c0,.015-.005.014-.005.021Zm12,2.453a.562.562,0,0,1-.543-.44h1.085a.561.561,0,0,1-.542.44Zm.973-1.32H14.643a2.332,2.332,0,0,0,.375-1.1.535.535,0,0,0,0-.054V15.339a1.68,1.68,0,1,1,3.359,0v1.729a2.335,2.335,0,0,0,.375,1.1Z" transform="translate(-2.5 -2.147)" fill="#fff"/>
        </svg>
        `,
            group: '',
            listed: true,
            page_name: "التذكيرات (جديد)"
        },
    },
    


    
]